import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(originalError) {
    const error = new Error(`Error in ${this.props.name}: ${originalError.message}`, {
      cause: originalError
    });
    this.props.logger.error(error);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      as: ErrorComponent
    } = this.props;
    if (hasError) {
      return ErrorComponent ? /*#__PURE__*/_jsx(ErrorComponent, {}) : null;
    }
    return this.props.children;
  }
}